import Axios from "axios";

export default (token) => {
    if (token) {
        Axios.defaults.headers.common.authorization = `Bearer ${token.access_token}`;
    } else {
        delete Axios.defaults.headers.common.authorization;
    }
};